import LabourPalnningService from '../../services/labourPalnningService';
const state = {
	storeName: "",
	sectionDetailsData: [],
	sectionTableLoadingStore: false,
	isTeamDataChanged: false
};
const mutations = {
	SET_STORE_NAME(state, storeName) {
		state.storeName = storeName;
	},
	SET_TEAM_DATA_CHANGE(state, val) {
		state.isTeamDataChanged = val;
	}
};
const actions = {
	setStoreName({ commit }, storeName) {
		commit("SET_STORE_NAME", storeName);
	},
	setTeamDataChanges({ commit }, val) {
		commit("SET_TEAM_DATA_CHANGE", val);
	},
	getSectionDetailsAction({ commit }, storeId) {
		state.sectionTableLoadingStore = true;
		const params = {
			store: storeId,
			departments: []
		};
		LabourPalnningService.getSections(params).then((response) => {
			state.sectionDetailsData = JSON.parse(response.data);
		}).then(() => {
			state.sectionTableLoadingStore = false;
		}).catch((error) => {
			state.sectionTableLoadingStore = false;
			console.error(error);
		});
	},
};

export default {
	state,
	mutations,
	actions,
	namespaced: true
};
